import { Tabs, Text } from "dash-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import MarketingFilesWrapper from "./components/MarketingFilesWrapper/MarketingFilesWrapper";
import PortfolioFolderItemsSelect from "./components/PortfolioFolderItemsSelect/PortfolioFolderItemsSelect";
import { TabsWrapper } from "./MediaKit.styles";

// Needs to be wrapped in a FormContext. See fields in "ManageMediaKitModal.constants.ts"
const MediaKit = ({
  isFolder,
  portfolioFolderId,
  isEdit,
  compactMediaList,
  onBulkAction,
  isLoading,
}: {
  isFolder?: boolean;
  portfolioFolderId?: string;
  isEdit?: boolean;
  compactMediaList?: boolean;
  onBulkAction?: ({ mode }: { mode: "add" | "remove" }) => void;
  isLoading?: boolean;
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("files");

  return (
    <div className="flex flex-col relative w-full">
      {!isEdit && (
        <>
          <Text lg semibold>
            {t("pages:mediaKit.dashDownloads")}
          </Text>
          <Text color={theme.colors.n80}>
            {t("pages:mediaKit.mediaKitText")}
          </Text>
        </>
      )}
      <TabsWrapper
        className="w-full flex flex-col"
        mt={3.5}
        p={4}
        isFolder={isFolder}>
        {isFolder && portfolioFolderId && (
          <PortfolioFolderItemsSelect
            portfolioFolderId={portfolioFolderId}
            onBulkAction={onBulkAction}
            isLoading={isLoading}
          />
        )}
        <Tabs
          isFullWidthTabs
          variation="secondary"
          activeTab={activeTab}
          tabs={[
            { label: t("pages:mediaKit.propertyMediaFiles"), key: "files" },
            {
              label: t("pages:mediaKit.addedToDashDownloads", {
                total: "",
              }),
              key: "added",
            },
          ]}
          onClick={setActiveTab}
        />
        <MarketingFilesWrapper
          isAddedToMediaKit={activeTab !== "files"}
          compactMediaList={compactMediaList}
        />
      </TabsWrapper>
    </div>
  );
};

export default MediaKit;
